export const mapResponsePagination = (data: any) => {
  const { currentPage, pageSize, totalCount, totalPages } = data;
  return {
    currentPage,
    pageSize,
    totalCount,
    totalPages,
  };
};
